import { render } from "./Sidebar.vue?vue&type=template&id=6c692cd3&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=6c692cd3&scoped=true&lang=css"

import exportComponent from "/home/schiavon/Documentos/Projects/RESTRICTED_WP/frontend_administrativo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c692cd3"]])

export default __exports__